import { render, staticRenderFns } from "./ClubVotes.vue?vue&type=template&id=f3f8d6a0"
import script from "./ClubVotes.vue?vue&type=script&lang=js"
export * from "./ClubVotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports